import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { fetchDataFromFirebaseCycle, fetchAverage } from '../FireBase/firebaseService'; // Fichier contenant les fonctions Firebase
import { fetchDataFromFirebaseGPS } from '../FireBase/firebaseService'; // Importation de la fonction GPS

// Enregistrement des composants nécessaires pour Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const FirebaseChart = ({ field }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const collectionName = localStorage.getItem('collectionName') || '/data';
  const [moyenne, setMoyenne] = useState(null);

  useEffect(() => {
    if (field !== "altitude") {
      const unsubscribe = fetchAverage(
        collectionName,
        field,
        (average) => setMoyenne(average),
        (error) => console.error(error)
      );
      return () => unsubscribe();
    }
  }, [collectionName, field]);

  useEffect(() => {
    if (field === "altitude") {
      // Récupération des données GPS
      const unsubscribe = fetchDataFromFirebaseGPS(
        collectionName,
        (fetchedData) => {
          if (fetchedData.length === 0) {
            setChartData(null);
            setLoading(false);
            return;
          }
          const nbPoints = localStorage.getItem('nbPoints') || 30;
          const recentData = fetchedData.slice(-nbPoints);
          const labels = recentData.map((_, index) => `Point ${index + 1}`);
          const data = recentData.map((point) => point.altitude);

          setChartData({
            labels,
            datasets: [
              {
                label: "Altitude over Time",
                data,
                borderColor: 'rgba(255, 159, 64, 1)',
                backgroundColor: 'rgba(255, 159, 64, 0.2)',
                tension: 0.4,
              },
            ],
          });
          setLoading(false);
        },
        (fetchError) => {
          setError(fetchError);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } else {
      // Récupération des autres données normales
      const unsubscribe = fetchDataFromFirebaseCycle(
        collectionName,
        (fetchedData) => {
          const nbPoints = localStorage.getItem('nbPoints') || 30;
          const recentData = fetchedData.slice(-nbPoints);
          const labels = recentData.map((_, index) => `Point ${fetchedData.length - nbPoints + index + 1}`);
          const data = recentData.map((point) => point[field]);

          const moyenneData = moyenne !== null ? new Array(recentData.length).fill(moyenne) : [];

          setChartData({
            labels,
            datasets: [
              {
                label: `${field} over Time`,
                data,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.4,
              },
              {
                label: `Moyenne de ${field}`,
                data: moyenneData,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderDash: [5, 5],
                tension: 0,
                pointRadius: 0,
              },
            ],
          });
          setLoading(false);
        },
        (fetchError) => {
          setError(fetchError);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    }
  }, [collectionName, field, moyenne]);

  if (loading) return <p>Chargement des données...</p>;
  if (error) return <p>Erreur : {error.message}</p>;
  if (!chartData) return <p>Aucune donnée à afficher.</p>;

  return (
    <div>
      <h2>Graphique de {field === "S" ? "Vitesse" : field}</h2>
      <Line
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            },
          },
        }}
      />
    </div>
  );
};

export default FirebaseChart;
